import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "translatedText", "button", "loading",
    "chooseLanguageForm", "submitButton", "toLang"
  ];
  static values = {
    pid: String,
    text: String,
    from: String,
  }

  connect() {
    this.url = "/translations?pid=PID&to=LANG";
    this.subscribed = window.subscribed || false;
  }

  chooseLanguage(ev) {
    ev.preventDefault();

    if (!this.subscribed) {
      this.show_message(this.subscribe_message);
      return;
    }

    if (this.hasChooseLanguageFormTarget) {
      this.chooseLanguageFormTarget.classList.toggle('d-none');
    }
  }

  translate(ev) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.classList.add('disabled');
    }
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove('d-none');
    }

    let fetchUrl = '/translations';
    let fetchHeaders = {
      'Content-Type': 'application/json',
      "Accept": "application/json"
    };

    if (this.csrf_token) {
      fetchHeaders["X-CSRF-Token"] = this.csrf_token;
    }

    let fetchOptions = {
      method: 'POST',
      credentials: 'same-origin',
      headers: fetchHeaders
    };

    if (this.hasTextValue && this.textValue) {
      fetchOptions.body = JSON.stringify({
        text: this.textValue,
        from: this.hasFromValue ? this.fromValue : 'en',
        to: this.hasToLangTarget ? this.toLangTarget.value : 'ar'
      });
    } else if (this.hasPidValue && this.pidValue) {
      fetchUrl = this.urlWithParams;
      fetchOptions.body = null;
    }

    fetch(fetchUrl, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error("Server status " + response.status);
        }
        return response.json();
      })
      .then(data => {
        if (data && data.ok) {
          this.generateTranslation(data.text || data.message);
          if (this.hasButtonTarget) this.buttonTarget.classList.add('d-none');
          if (this.hasChooseLanguageFormTarget) this.chooseLanguageFormTarget.classList.add('d-none');
        } else {
          const errMsg = (data && (data.message || data.error)) ? (data.message || data.error) : "Translation failed.";
          this.show_message(errMsg);
        }

        if (this.hasLoadingTarget) this.loadingTarget.classList.add('d-none');
        if (this.hasSubmitButtonTarget) {
          this.submitButtonTarget.disabled = false;
          this.submitButtonTarget.classList.remove('disabled');
        }
      })
      .catch(err => {
        console.error('Translation fetch error:', err);
        this.show_message(err.message || "Translation error occurred.");
        if (this.hasLoadingTarget) this.loadingTarget.classList.add('d-none');
        if (this.hasSubmitButtonTarget) {
          this.submitButtonTarget.disabled = false;
          this.submitButtonTarget.classList.remove('disabled');
        }
      });
  }

  generateTranslation(text) {
    if (!text || !this.hasTranslatedTextTarget) return;
    this.translatedTextTarget.innerHTML = '';
    let node = this.generateNode(text);
    this.translatedTextTarget.innerHTML = node;
  }

  generateNode(text) {
    const node = document.createElement('p');
    node.classList.add('text-right', 'fw-bold', 'text-success', 'mt-2', 'p-3', 'bg-light', 'rounded-3', 'border');
    node.innerHTML = text;
    return node.outerHTML;
  }

  show_message(text) {
    if (!this.hasTranslatedTextTarget) return;
    const safeText = text || "Translation error occurred.";
    this.translatedTextTarget.innerHTML = '';
    const node = document.createElement('div');
    node.innerHTML = safeText;
    node.classList.add('alert', 'alert-danger', 'mt-2');
    this.translatedTextTarget.innerHTML = node.outerHTML;
  }

  get subscribe_message() {
    return `
      <p class="text-xl">Please subscribe to a translation plan to activate this feature.</p>
      <a href="/plans#translation" class="btn btn-light mt-3">Subscribe</a>
    `
  }

  get urlWithParams() {
    const pid = this.hasPidValue ? this.pidValue : '';
    const to = this.hasToLangTarget ? this.toLangTarget.value : '';
    return this.url
      .replace('PID', pid)
      .replace('LANG', to);
  }

  get csrf_token() {
    const meta = document.querySelector("meta[name='csrf-token']");
    return meta ? meta.content : null;
  }
}
